import { Injectable } from '@angular/core';
import { Observable, takeUntil, tap, timer } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RequestReplayService {

    requestReplays: Map<string, Observable<any>> = new Map<string, Observable<any>>();

    constructor() {
        
    }

    public saveRequestReplay(tableKey: string, request: Observable<any>, tableUUID?: string) {
        let searchKey = tableKey;
        if (!String.isNullOrUndefinedOrWhitespace(tableUUID)) {
            searchKey += `-${tableUUID}`;
        }

        let obsCloseTimer = timer(60000).pipe(tap(() => this.removeRequestReplay(searchKey)))

        this.requestReplays.set(searchKey, request.pipe(takeUntil(obsCloseTimer)));
    }

    public removeRequestReplay(tableKey: string, tableUUID?: string) {
        let searchKey = tableKey;
        if (!String.isNullOrUndefinedOrWhitespace(tableUUID)) {
            searchKey += `-${tableUUID}`;
        }

        this.requestReplays.delete(searchKey);
    }

    public getRequestReplay(tableKey: string, tableUUID?: string) {
        let searchKey = tableKey;
        if (!String.isNullOrUndefinedOrWhitespace(tableUUID)) {
            searchKey += `-${tableUUID}`;
        }

        let replay = this.requestReplays.get(searchKey);

        if (replay) {
            return replay;
        }

        return undefined;
    }
    
    public clearRequestReplays() {
        this.requestReplays.clear();
    }
}